import { handleResponse } from './handleresponse'
import { apiurl } from '@/services/config'
const API_URL = apiurl

export const serviceUpload = {
  uploadimage,
  newuploadimage
}

function uploadimage (image) {
  const formData = new FormData()
  formData.append('file', image)
  return fetch('https://api.aviana.id:9780/upload', {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function newuploadimage (image) {
  const formData = new FormData()
  formData.append('file', image)
  return fetch(API_URL + '/api/admin/v2/upload/image', {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

// function handleResponse (response) {
//   return response.text().then(text => {
//     const data = text && JSON.parse(text)
//
//     if (response.status === 200) {
//       if (data.access_token) {
//         return data
//       }
//     }
//
//     if (!data.success) {
//       if (response.status === 401) {
//       }
//       const error = (data && data.error) || response.statusText
//       return Promise.reject(error)
//     }
//     return data
//   })
// }
